const getWidgets = () => [
  document.querySelector('.uwy.userway_p1'),
  document.querySelector('#Avada-FAQ_Widget')
].filter(el => el);

let isMobile = window.matchMedia('(max-width: 640px)').matches;
let ticking = false;

window.addEventListener('resize', () => {
  isMobile = window.matchMedia('(max-width: 640px)').matches;
  requestTick();
});

function updateOpacity() {
  const widgets = getWidgets();
  if (widgets.length === 0) {
    ticking = false;
    return;
  }

  const scrollY = window.scrollY;
  const shouldShow = isMobile && scrollY > 600;

  widgets.forEach(el => {
    const currentOpacity = el.style.opacity;
    const newOpacity = shouldShow ? '1' : '';

    if (currentOpacity !== newOpacity) {
      el.style.opacity = newOpacity;
    }
  });

  ticking = false;
}

function requestTick() {
  if (!ticking) {
    window.requestAnimationFrame(updateOpacity);
    ticking = true;
  }
}

window.addEventListener('scroll', requestTick, { passive: true });

if (document.readyState === 'complete') {
  requestTick();
} else {
  window.addEventListener('load', requestTick);
}

let attempts = 0;
const interval = setInterval(() => {
  requestTick();
  attempts++;
  if (attempts >= 8) clearInterval(interval);
}, 500);

//Free Gift
document.addEventListener('DOMContentLoaded', function() {
  const targetVariantId = '46669719896282'; 
  const promoStartDate = new Date('2026-04-08T00:00:00-04:00'); 
  const promoEndDate = new Date('2026-04-15T23:59:59-04:00'); 
  const now = new Date();

  if (now >= promoStartDate && now <= promoEndDate) {
    
    function enforceMaxQuantity() {
      const cartLinks = document.querySelectorAll(`a[href*="${targetVariantId}"]`);
      
      cartLinks.forEach(link => {
        const cartItem = link.closest('.cart-item, .cart__item, tr, .drawer__cart-item');
        if (cartItem) {
           const qtyInput = cartItem.querySelector('input[type="number"], input[name="updates[]"]');
           const plusBtn = cartItem.querySelector('button[name="plus"], .quantity__button[name="plus"]');

           if (qtyInput) {
             qtyInput.setAttribute('max', '1');
             qtyInput.value = '1';
             qtyInput.readOnly = true;
           }
           
           if (plusBtn) {
             plusBtn.style.pointerEvents = 'none';
             plusBtn.style.opacity = '0.4'; 
           }
        }
      });
    }

    enforceMaxQuantity();

    const observer = new MutationObserver(function(mutations) {
      enforceMaxQuantity();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
});